import Icon from '@components/v2/ui/Icon/Icon';
import { Box, Dialog, Grid, IconButton } from '@mui/material';
import { Alert } from '@mui/material';
import { QrcodeSuccessCallback } from 'html5-qrcode/esm/core';
import { X } from 'lucide-react';
import useWidth from '../../../../../components/Hooks/useWidth';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import BarcodeReaderDialogContent from './BarcodeReaderDialogContent';

interface BarcodeReaderDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: QrcodeSuccessCallback;
}

const BarcodeReaderDialog = ({ open, onClose, onSuccess }: BarcodeReaderDialogProps) => {
  const { mobileWidth } = useWidth();
  const { translate } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullScreen={mobileWidth}>
      <Box
        sx={{
          padding: 2,
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Grid size="grow">
            <Alert severity="info">
              {translate(LangEnum.ORDER_ADD_PRODUCT_BARCODE_MODAL_MESSAGE)}
            </Alert>
          </Grid>
          <Grid>
            <IconButton onClick={onClose} size="small" sx={{ color: 'action.active' }}>
              <Icon icon={X} size="lg" />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <BarcodeReaderDialogContent onSuccess={onSuccess} />
    </Dialog>
  );
};
export default BarcodeReaderDialog;
